import api from './api';

const notificationService = {
  sendPromotional: (payload) =>
    api.post('/notifications/admin/promotional', payload).then((r) => r.data),
  getPromotionalHistory: () =>
    api.get('/notifications/admin/promotional').then((r) => r.data),

  // Promo Banners
  getActivePromoBanners: () =>
    api.get('/notifications/promo-banners').then((r) => r.data),
  getAllPromoBanners: () =>
    api.get('/notifications/admin/promo-banners').then((r) => r.data),
  createPromoBanner: (payload) =>
    api.post('/notifications/admin/promo-banners', payload).then((r) => r.data),
  updatePromoBanner: (id, payload) =>
    api.patch(`/notifications/admin/promo-banners/${id}`, payload).then((r) => r.data),
  deletePromoBanner: (id) =>
    api.delete(`/notifications/admin/promo-banners/${id}`).then((r) => r.data),
};

export default notificationService;
